<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <!-- <img src="@assets/images/pages/register.jpg" alt="register" class="mx-auto"> -->
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="px-8 pt-8 register-tabs-container">
                                <div class="vx-card__title mb-4">
                                    <h4 class="mb-4">Create Account</h4>
                                    <p>Fill the below form to create a new account.</p>
                                </div>
                                <vs-tabs>
                                  <vs-tab label="JWT">
                                    <div class="clearfix">
                                      <vs-input
                                        v-validate="'required|alpha_dash|min:3'"
                                        data-vv-validate-on="blur"
                                        label-placeholder="Name"
                                        name="first_name"
                                        placeholder="Name"
                                        v-model="first_name"
                                        class="w-full" />
                                      <span class="text-danger text-sm">{{ errors.first('first_name') }}</span>

                                      <vs-input
                                        v-validate="'required|alpha_dash|min:3'"
                                        data-vv-validate-on="blur"
                                        label-placeholder="Name"
                                        name="last_name"
                                        placeholder="Name"
                                        v-model="last_name"
                                        class="w-full" />
                                      <span class="text-danger text-sm">{{ errors.first('last_name') }}</span>

                                      <vs-input
                                        v-validate="'required|email'"
                                        data-vv-validate-on="blur"
                                        name="email"
                                        type="email"
                                        label-placeholder="Email"
                                        placeholder="Email"
                                        v-model="email"
                                        class="w-full mt-6" />
                                      <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                                      <vs-input
                                        ref="password"
                                        type="password"
                                        data-vv-validate-on="blur"
                                        v-validate="'required|min:6|max:15'"
                                        name="password"
                                        label-placeholder="Password"
                                        placeholder="Password"
                                        v-model="password"
                                        class="w-full mt-6" />
                                      <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                      <vs-input
                                        type="password"
                                        v-validate="'required|min:6|max:15|confirmed:password'"
                                        data-vv-validate-on="blur"
                                        data-vv-as="password"
                                        name="confirm_password"
                                        label-placeholder="Confirm Password"
                                        placeholder="Confirm Password"
                                        v-model="confirm_password"
                                        class="w-full mt-6" />
                                      <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

                                      <vs-input type="text" name="role" v-model="role" />
                                      <vs-input type="text" name="phone" v-model="phone" />

                                      <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms & conditions.</vs-checkbox>
                                      <vs-button  type="border" to="/login" class="mt-6">Login</vs-button>
                                      <vs-button type="relief" ref="userRegisterBtnRef" id="userRegisterBtn" class="vs-con-loading__container float-right mt-6" @click="registerUserJWt" >Register</vs-button>
                                    </div>
                                  </vs-tab>

                                </vs-tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

import { Validator } from 'vee-validate';
const dict = {
  custom: {
    first_name: {
      required: 'Please enter your first name',
      alpha: "Your first name may only contain alphabetic characters"
    },
    last_name: {
      required: 'Please enter your last name',
      alpha: "Your last name may only contain alphabetic characters"
    },
  }
};
// register custom messages
Validator.localize('en', dict);

export default {
    components: {

    },
    data() {
        return {
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            confirm_password: '',
            isTermsConditionAccepted: false,
            role: 'admin',
            phone: '22136710'
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.first_name != '' && this.last_name != ''&& this.email != '' && this.password != '' && this.confirm_password != '' && this.isTermsConditionAccepted === true;
        }
    },
    methods: {
        checkLogin() {
          // If user is already logged in notify
          if(this.$store.state.auth.isUserLoggedIn()) {

            // Close animation if passed as payload
            // this.$vs.loading.close()

            this.$vs.notify({
              title: 'Login Attempt',
              text: 'You are already logged in!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }
          return true
        },
        registerUserJWt() {
          var self = this
          // this.$validator.validateAll().then(result => {
          //   if(result) {
          //     console.log("no")

          //   }else{
          //     console.log("yes")
          //   }
          // })

          // If form is not validated or user is already login return
          if (!this.validateForm || !this.checkLogin()) return

          this.$vs.loading({
            background: 'primary',
            color: '#fff',
            container: "#userRegisterBtn",
            scale: 0.45
          })

          const payload = {
            userDetails: {
              first_name: this.first_name,
              last_name: this.last_name,
              email: this.email,
              password: this.password,
              confirmPassword: this.confirm_password,
              role: this.role,
              phone: this.phone
            },
            notify: this.$vs.notify
          }

          this.$store.dispatch('auth/registerUserJWT', payload)
            .then((response) => { 
              this.$router.push('/dashboard').catch(() => {})
              
              this.$vs.notify({
                title: 'Hi '+this.first_name+' '+this.last_name,
                text: 'Your account successfully created',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })

              this.$vs.loading.close("#userRegisterBtn > .con-vs-loading")
            })
            .catch(error => {
              if(error.status == 422){
                Object.keys(error.data).forEach(function(key) {
                  self.errors.add({
                    field: key,
                    msg: error.data[key][0],
                  });
                });
              }

              this.$vs.loading.close("#userRegisterBtn > .con-vs-loading")
            })
        }
    }
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
